import { ConcessaoVeiculo } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { ConcessaoVeiculoService } from 'app/services/mob/concessao-veiculo.service';
import { ConcessaoVeiculoDTO } from 'app/model/dtos/mob/concessao-veiculo.dto';
import { FormGroup, FormControl, ControlContainer } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ConcessaoVeiculoSearch } from 'app/services/mob/concessao-veiculo.search';
import { ConcessaoVeiculoSituacao } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-veiculo-situacao.enum';

 @Component({
  selector: 'autocomplete-placa-escolar',
  templateUrl: './autocomplete-placa-escolar.component.html',
  styleUrls: ['./autocomplete-placa-escolar.component.scss'],
  viewProviders: [ParentFormGroup],
})
export class AutocompletePlacaEscolarComponent implements OnInit {
  formGroup: FormGroup;
  concessaoVeiculos: ConcessaoVeiculoDTO[]
  filteredOptions: ConcessaoVeiculoDTO[]
  nrPlacaControl: FormControl;

  constructor(
    private _control: ControlContainer,
    private _concessaoVeiculoService: ConcessaoVeiculoService
  ) { }

  ngOnInit() {
    let filtro: ConcessaoVeiculoSearch = new ConcessaoVeiculoSearch({tpConcessao: ConcessaoTipo.ESCOLAR})
    this.nrPlacaControl = new FormControl('')
    this.formGroup = this._control.control as FormGroup;
    this.load(filtro)
    this.formGroup.get('cdConcessao').valueChanges.subscribe(async (value) => {
      this.load(new ConcessaoVeiculoSearch({cdConcessao:value, tpConcessao: ConcessaoTipo.ESCOLAR})) 
    })


    this.nrPlacaControl.valueChanges.subscribe(value => {
      if (value != '') {
        this.filteredOptions = this._filter(value)
      } else {
        this.filteredOptions = this.concessaoVeiculos
      }
    });
  }

  private _filter(value: string): ConcessaoVeiculoDTO[] {
    const filterValue = value.toUpperCase();

    return this.concessaoVeiculos.filter(option => option.veiculo.nrPlaca.toString().toUpperCase().indexOf(filterValue) === 0);
  }

  mudaCdConcessaoVeiculo(valor) {
    if (this.formGroup.get('cdConcessaoVeiculo')) {
      this.formGroup.get("cdConcessaoVeiculo").setValue(valor ? valor.concessaoVeiculo.cdConcessaoVeiculo : null)
    }
    if (this.formGroup.get("cdVeiculo")) {
      this.formGroup.get("cdVeiculo").setValue(valor ? valor.veiculo.cdVeiculo : null)
    }
  }

  async load(filtro: ConcessaoVeiculoSearch) {
    
    this.concessaoVeiculos = await this._concessaoVeiculoService.findVeiculos(filtro)
    if (this.formGroup.get('cdVeiculo') && this.formGroup.get('cdVeiculo').value) {
      this.concessaoVeiculos.map(value =>{
        if(value.cdVeiculo == this.formGroup.get('cdVeiculo').value){
          this.nrPlacaControl.setValue(value.veiculo.nrPlaca)
        }
      })
    }
    this.filteredOptions = this.concessaoVeiculos
  }

}
